<div class="container">
  <h4>Camera User</h4>
  <form #userForm="ngForm" (ngSubmit)="userForm.form.valid && saveUser()">
    <div class="row row-cols-1 row-cols-md-3">
      <div class="col mb-3">
        <label for="txtName">Name</label>
        <input
          #txtName="ngModel"
          [(ngModel)]="user.Name"
          type="text"
          name="txtName"
          id="txtName"
          class="form-control"
          required />
        @if (
          ((txtName.touched && txtName.dirty) || userForm.submitted) &&
          txtName.errors?.required
        ) {
          <small class="text-danger">Name is required</small>
        }
      </div>
      <div class="col mb-3">
        <label for="txtEmail">Email</label>
        <input
          #txtEmail="ngModel"
          [(ngModel)]="user.EmailAddress"
          type="text"
          name="txtEmail"
          id="txtEmail"
          class="form-control"
          placeholder="first.last@valmont.com"
          required
          email />
        <!-- pattern="^[A-Za-z0-9._%+-]+@(valmont\.com)" -->
        @if (
          ((txtEmail.touched && txtEmail.dirty) || userForm.submitted) &&
          txtEmail.errors?.required
        ) {
          <small class="text-danger">Email is required</small>
        }
        @if (
          ((txtEmail.touched && txtEmail.dirty) || userForm.submitted) &&
          (txtEmail.errors?.email || txtEmail.errors?.pattern)
        ) {
          <small class="text-danger"
            >Invalid Email format:
            <strong>user&#64;<i>valmont.com</i></strong></small
          >
        }
      </div>
      <div class="col mb-3">
        <label for="txtUPN">User ID</label>
        <input
          #txtUPN="ngModel"
          [(ngModel)]="this.user.Upn"
          type="text"
          name="txtUPN"
          id="txtUPN"
          class="form-control"
          placeholder="userid@domain.valmont.com"
          required
          email
          pattern="^[A-Za-z0-9._%+-]+@(na|as)(\.valmont\.com)" />
        @if (
          ((txtUPN.touched && txtUPN.dirty) || userForm.submitted) &&
          txtUPN.errors?.required
        ) {
          <small class="text-danger">User ID is required</small>
        }
        @if (
          ((txtUPN.touched && txtUPN.dirty) || userForm.submitted) &&
          (txtUPN.errors?.email || txtUPN.errors?.pattern)
        ) {
          <small class="text-danger"
            >Invalid User ID format:
            <strong>user&#64;<i>[na|as]</i>.valmont.com</strong></small
          >
        }
      </div>
      <div class="col mb-3">
        <label for="cboCountry">Select an country</label
        ><select
          #cboCountry="ngModel"
          name="cboCountry"
          [(ngModel)]="selectedCountryId"
          id="cboCountry"
          class="form-control form-select"
          required
          (change)="changeCountry(cboCountry.value)">
          @for (country of this.countries; track country; let i = $index) {
            <option [ngValue]="country.Id">
              {{ country.Name }}
            </option>
          }
        </select>
        @if (
          ((cboCountry.touched && cboCountry.dirty) || userForm.submitted) &&
          cboCountry.errors?.required
        ) {
          <small class="text-danger">An country should be selected</small>
        }
      </div>
      <div class="col mb-3">
        <label for="txtMobilePhone">Mobile Phone</label>
        <div class="input-group">
          <input
            #txtMobilePhone="ngModel"
            [(ngModel)]="this.user.Mobile"
            type="text"
            name="txtMobilePhone"
            id="txtMobilePhone"
            class="form-control"
            placeholder="Mobile Phone" />
          <button
            class="btn btn-outline-primary"
            title="Find User's Mobile Phone"
            type="button"
            (click)="findUserMobilePhone()">
            <fa-icon [icon]="icons.search"></fa-icon>
          </button>
        </div>
        @if (
          ((txtMobilePhone.touched && txtMobilePhone.dirty) ||
            userForm.submitted) &&
          txtMobilePhone.errors?.mask
        ) {
          <small class="text-danger"
            >Invalid Mask. Format: {{ phoneMask }}</small
          >
        }
      </div>
    </div>
    <div class="row row-cols-1 row-cols-md-3">
      <div class="col me-auto">
        <div class="form-check form-switch custom-switch-info">
          <input
            type="checkbox"
            class="form-check-input"
            id="chkAdmin"
            name="chkAdmin"
            [(ngModel)]="this.user.IsAdmin" />
          <label class="form-check-label" for="chkAdmin"
            >Is Global Admin
          </label>
        </div>
      </div>
      <div class="col text-end">
        @if (isNew) {
          <button
            type="button"
            class="btn btn-outline-success btn-sm"
            (click)="openAdUserSearch()">
            <fa-icon [icon]="icons.search"></fa-icon> Search
          </button>
        }
        @if (!isNew) {
          <button
            type="button"
            [disabled]="!isReady"
            class="btn btn-sm btn-outline-danger"
            (click)="deleteUser()">
            Delete
          </button>
        }
        <button
          type="button"
          [disabled]="!isReady"
          [routerLink]="['/admin', 'users']"
          class="btn btn-sm btn-secondary mx-1">
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="
            (userForm.form.dirty && !userForm.form.valid) || !siteSelected
          "
          class="btn btn-sm btn-primary">
          Save
        </button>
      </div>
    </div>

    <div class="p-1">
      <ngb-alert type="info" [hidden]="isReady" [dismissible]="false" class="">
        <fa-icon animation="spin-pulse" [icon]="icons.spinner"></fa-icon>
        {{ this.alertMsg }}
      </ngb-alert>
    </div>
    @if (!user.IsAdmin) {
      <app-admin-site-picker
        [(isReady)]="isReady"
        [(sites)]="sites"></app-admin-site-picker>
    }
  </form>
</div>
